let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
export const RteEditorGlobalStyles = createGlobalStyle(_t || (_t = _`
  @media only screen and (max-width: 544px) {
    .styled-snippets-popover {
      width: 300px !important;

      h5 ~ div {
        display: flex;
        flex-direction: column;
      }
    }
  }

  [data-at-mention],
  .at-mention-token {
    font-weight: ${0};
    &::before {
      content: '@';
      padding-right: ${0};
      color: ${0};
      font-weight: ${0};
    }
  }

  [data-test-id="rich-text-editor"] {
    position: relative;

    .rich-text-editor-input.rte-border {
      border: ${0} solid;
      border-color: ${0};
      padding: ${0};
      margin-bottom: ${0};
      box-shadow: ${0};
      border-radius: ${0};
    }

    .ProsemirrorEditor__body {
      min-height: ${0};
      display: flex;
      flex-direction: column;
    }
    .ProseMirror {
      flex-grow: 1;
    }
  }
`), ({
  theme
}) => theme.typography['body-125'].fontWeight, ({
  theme
}) => theme.space['25'], ({
  theme
}) => theme.color['fill-accent-neutral-default'], ({
  theme
}) => theme.typography['body-125'].fontWeight, ({
  theme
}) => theme.borderWidth['200'], ({
  theme
}) => theme.color['border-interactive-default'], ({
  theme
}) => {
  const {
    space
  } = theme;
  return `${space['100']} ${space['100']} ${space['0']} ${space['100']}`;
}, ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.boxShadow['200'], ({
  theme
}) => theme.borderRadius['100'], ({
  theme
}) => theme.space['1100']);